// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const BZ2_GRID_WATCHDOG_FILTER_SAVED_WITH_unsubscribe = "Toto hled\u00e1n\u00ed m\u00e1\u0161 ulo\u017een\u00e9. Jestli u\u017e nechce\u0161 dost\u00e1vat e-maily, %(unsubscribe)s.";
export const BZ2_GRID_WATCHDOG_SAVE_FILTER = "Ulo\u017e hled\u00e1n\u00ed";
export const BZ2_GRID_WATCHDOG_SAVE_FILTER_MESSAGE = "<strong>Ulo\u017e si toto hled\u00e1n\u00ed</strong> a my ti po\u0161leme e-mail, kdy\u017e n\u011bkdo p\u0159id\u00e1 inzer\u00e1t.";
export const BZ2_GRID_WATCHDOG_UNSUBSCRIBE = "zru\u0161 ulo\u017een\u00ed";
